module.exports = __webpack_public_path__ + "static/communicate-d0d72b985a341fad245853d9201e9cd5.gif";